/**
 * Une réservation est « sur la terrasse » si le client l'a choisie OU si elle est
 * placée sur une table / combinaison terrasse. Règle unique partagée par l'onglet
 * Terrasse, la fenêtre de désactivation et l'alerte « à replacer ».
 */
export interface TerraceCheckableReservation {
  status?: string | null;
  terracePreference?: string | null;
  tableId?: string | null;
  combinedTableId?: string | null;
}

export function isReservationOnTerrace(
  r: TerraceCheckableReservation,
  terraceTableIds: Set<string>,
  terraceCombinedIds: Set<string>,
): boolean {
  if (r.status === 'annulé') return false;
  if (r.terracePreference === 'terrace') return true;
  return (!!r.tableId && terraceTableIds.has(r.tableId))
    || (!!r.combinedTableId && terraceCombinedIds.has(r.combinedTableId));
}

/** Réservations à venir (date >= aujourd'hui, non arrivées/annulées) encore sur la terrasse. */
export function getUpcomingTerraceReservations<T extends TerraceCheckableReservation & { date: Date | string }>(
  reservations: T[],
  terraceTableIds: Set<string>,
  terraceCombinedIds: Set<string>,
  todayStr: string,
): T[] {
  return reservations
    .filter(r => r.status !== 'arrivé')
    .filter(r => {
      const d = typeof r.date === 'string' ? r.date.slice(0, 10) : toLocalDateStr(r.date);
      return d >= todayStr;
    })
    .filter(r => isReservationOnTerrace(r, terraceTableIds, terraceCombinedIds));
}

function toLocalDateStr(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
